<template>
  <div>
    <a href="https://www.biopama.org/"> <span class="popup-close">+</span> </a>
    <div class="left-panel">
      <div class="left-inner">
        <div class="language-switch-container">
          <locale-switch></locale-switch>
        </div>
        <div class="lp-signup">
          <p>{{$t("auth.register__top_line")}}</p>
          <a href="/auth/login" class="btn btn-primary btn-simple">{{$t("auth.btn_login")}}</a>
        </div>

        <h1>{{ $t('auth.register__confirmation') }}</h1>
        <div v-if="!initialized">
          <p class="mt-4">
            {{ $t("auth.register__please_wait") }}
          </p>
        </div>
        <div v-if="initialized">
          <p class="mt-4">{{ success ? $t("auth.register__confirm_success") : $t("auth.register__confirm_failed") }}</p>

          <div class="mt-5" v-if="success" slot="footer">
            <a href="/auth/login" class="btn btn-primary btn-simple">{{$t("auth.btn_login")}}</a>
          </div>
        </div>

      </div>
    </div>
    <div class="right-panel">
      <canvas class="strength-indicator" width="628" height="679"></canvas>
    </div>
  </div>
</template>


<script>
  import LocaleSwitch from "@/components/LocaleSwitch";
  import {AuthService} from "@/services";

  export default {
    data() {
      return {
        success: false,
        initialized: false
      };
    },
    components: {
      LocaleSwitch
    },
    methods: {
      async confirmRegistration() {
        await AuthService.confirmEmail(this.$route.params.token).then((response) => {
          this.success = true;
        }).catch((error) => {
          this.success = false;
        })

        this.initialized = true;
      }
    },
    beforeMount() {
      this.confirmRegistration();
    }
  };
</script>
<style lang="scss" scoped>
  h3 {
    margin-bottom: 7.020833vh;
  }

  .left-inner {
    max-width: 80%;
  }

  .terms-label {
    font-size: 1.62291667vh;
    font-weight: 400;
    margin-top: 2rem;
    color: $secondary;

    &.has-danger {
      a {
        color: $danger;
      }
    }

    a {
      text-decoration: underline;
    }
  }
</style>
